import React from 'react';
import { translate } from 'react-i18next';
import * as Common from 'common/components';

const RolesTable = ({
  count,
  children,
  order,
  orderBy,
  company,
  subcompany,
  permissions,
  handleToggle = () => {},
  handleOrderChange,
  isLoading,
  t = (key) => key,
}) => {
  const headers = [
    { variable: 'name', text: t('roles.fields.name') + ': ', type: 'h3' },
    {
      variable: 'default',
      text: t('roles.fields.default') + ': ',
      boolean: true,
    },
  ];

  const config = {
    actions: t('common.actions'), //Texto de seccion de acciones
    edit: t('common.edit'), //Texto de boton editar
    editPermission: 'acl.roles.update',
    togglePermission: 'acl.roles.toggle.notDeveloped',
    editUrl: 'roles', //Url para editar empleado
    propsName: 'role', //de donde se obtienen los props
    company: company,
    subcompany: subcompany,
  };

  const dataCard = {
    rows: children,
    headers: headers,
    config: config,
    permissions: permissions,
    handleClick: handleToggle,
  };
  return (
    <div className="table-responsive" style={{ position: 'relative' }}>
      {/* <table className="table table-hover table-striped"> */}
      <Common.List dataCard={dataCard}>
        <thead>
          <tr>
            <Common.ThSortable
              orderBy={orderBy}
              order={order}
              field="name"
              handleOrderChange={handleOrderChange}
            >
              {t('roles.fields.name')}
            </Common.ThSortable>
            <Common.ThSortable
              orderBy={orderBy}
              order={order}
              field="default"
              handleOrderChange={handleOrderChange}
              className="text-center"
            >
              {t('roles.fields.default', { context: 'male' })}
            </Common.ThSortable>
            <th className="text-center">{t('common.actions')}</th>
          </tr>
        </thead>
        <tbody>
          {!count && <Common.EmptyTable colSpan={6} />}
          {children}
        </tbody>
      </Common.List>
      {/* </table> */}
      <Common.LoaderOverlay show={isLoading} />
    </div>
  );
};

export default translate()(RolesTable);



// WEBPACK FOOTER //
// src/modules/secured/modules/roles/components/RolesTable.js